/**
 * What happens to each asset on a Support at home plan, in words (review, 18 Oct 2026: "View Details"
 * printed the engine's codes — "partiallySold", "upgraded" — and "Liquidated" as a heading; a couple's
 * two accounts called "MLC" were shown as "MLC" twice, with no way to tell his from hers).
 */
import type { DraftFactFind } from '../../constants/initialFactFind.ts';

const STATUS_WORDS: Record<string, string> = {
    sold: 'Sold in full',
    partiallySold: 'Partly sold',
    kept: 'Kept',
    new: 'New',
    upgraded: 'Moved to a dearer home',
    downsized: 'Moved to a cheaper home',
    repaid: 'Paid off',
    partiallyRepaid: 'Partly paid off',
    gifted: 'Given away',
};

export function assetStatusWords(status: unknown): string {
    const key = String(status ?? '');
    if (STATUS_WORDS[key]) return STATUS_WORDS[key];
    // An engine code this list has not met yet: split the camel case rather than print it raw.
    const spaced = key.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return spaced ? spaced[0].toUpperCase() + spaced.slice(1) : '';
}

/**
 * The asset's name as the client would say it: on a couple's file, an asset owned by one of them is
 * "Colin's MLC" (the same rule as the aged care money story). A joint asset, a single client's, or a
 * name that already carries the owner's is left as it is.
 */
export function allocationName(asset: { assetName?: string; ownership?: string } | null | undefined, factFind: DraftFactFind | null | undefined): string {
    const name = String(asset?.assetName || '').trim();
    if (!name || factFind?.adviceFor !== 'couple') return name;
    const owner = asset?.ownership === 'partner' ? factFind?.partner?.firstName : asset?.ownership === 'client' ? factFind?.client?.firstName : null;
    if (!owner) return name;
    return name.toLowerCase().includes(String(owner).toLowerCase()) ? name : `${owner}'s ${name}`;
}
